const page ="/iot/device/page";
const statistics ="/iot/device/statistics";

export default {
  page,statistics
  }
